var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn loading-overlay position-absolute w-100 h-100"},[_c('div',{staticClass:"bg-white w-100 h-100"}),_c('breeding-rhombus-spinner',{staticClass:"position-absolute",attrs:{"animation-duration":2000,"size":65,"color":"#2f353a"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }